import { styled } from 'styled-components';

import { colors, responsive } from '@/utils';

export const StyledGuide = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${responsive.spacing['5xlarge']};
  padding: ${responsive.spacing.large} ${responsive.spacing['5xlarge']};
`;

/** Markers inherit this color. Step text color comes from Typography. */
export const StyledStepList = styled.ol`
  display: flex;
  flex-direction: column;
  gap: ${responsive.spacing.small};
  margin: 0;
  padding-left: ${responsive.spacing.xlarge};
  color: ${colors.text.neutral.contrast};
`;
